import { motion } from "framer-motion";
import { ArrowRight, PhoneCall } from "lucide-react";

export default function FinalCTA() {
    // tiny particles array
    const particles = Array.from({ length: 22 });

    return (
        <section
            className="relative py-32 overflow-hidden"
            data-testid="final-cta-section"
        >
            <div className="absolute inset-0 bg-gradient-to-br from-blue-700/15 via-transparent to-emerald-500/15 pointer-events-none" />
            <div className="absolute inset-0 bg-grid bg-grid-fade opacity-40 pointer-events-none" />

            {/* particles */}
            <div className="absolute inset-0 pointer-events-none">
                {particles.map((_, i) => {
                    const left = (i * 53) % 100;
                    const top = (i * 37) % 100;
                    const dur = 6 + (i % 6);
                    return (
                        <motion.span
                            key={i}
                            className={`absolute rounded-full ${
                                i % 3 === 0
                                    ? "bg-emerald-400/70"
                                    : "bg-blue-400/70"
                            }`}
                            style={{
                                width: i % 4 === 0 ? 4 : 2,
                                height: i % 4 === 0 ? 4 : 2,
                                left: `${left}%`,
                                top: `${top}%`,
                            }}
                            animate={{
                                y: [0, -30, 0],
                                opacity: [0.2, 1, 0.2],
                            }}
                            transition={{
                                duration: dur,
                                repeat: Infinity,
                                delay: (i * 0.13) % 3,
                            }}
                        />
                    );
                })}
            </div>

            <div className="pr-container relative">
                <div className="pr-glass-strong rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden">
                    <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-blue-500/20 rounded-full blur-3xl pointer-events-none" />
                    <motion.span
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="pr-chip-green pr-chip"
                    >
                        Let's start the conversation
                    </motion.span>

                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.05 }}
                        className="mt-5 font-outfit font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter"
                    >
                        <span className="headline-gradient">
                            Ready to access real
                        </span>
                        <br />
                        <span className="text-white">
                            <span className="accent-gradient">market intelligence</span>?
                        </span>
                    </motion.h2>

                    <p className="mt-5 max-w-xl mx-auto text-slate-300 leading-relaxed">
                        Tell us your audience and timeline. We'll come back with
                        a sample plan, methodology and price within one
                        business day.
                    </p>

                    <div className="mt-9 flex flex-wrap justify-center gap-4">
                        <a
                            href="#lead-form"
                            className="btn-primary"
                            data-testid="final-cta-quote"
                        >
                            Get a Quote
                            <ArrowRight className="w-4 h-4" />
                        </a>
                        <a
                            href="#lead-form"
                            className="btn-secondary"
                            data-testid="final-cta-callback"
                        >
                            <PhoneCall className="w-4 h-4" />
                            Request a Call Back
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
